module.exports = __webpack_public_path__ + "static/media/icon-speaker.12792067.svg";